/* ==========================================================================
   Suki x Invisible Building 2.0 - featured-images.js

   Load more for the homepage "Browse our favourites" cards
   (sections/featured-images.liquid). On desktop only the first row of three
   shows; the rest carry .feat-images__item--more and wait. The button deals
   the next three in when pressed (never on its own while scrolling). It
   fades out as the cards come, then returns below them while any are left.
   Below 990px the cards are a swipe strip and all of them show, so the CSS
   hides the button.

   Loaded `defer` by the section (after theme.js) only when there are more
   than three cards and the page is not in the theme editor.

   Hook contract
   ------------------------------------------------------------------------
   Root     [data-fi-more] wrapper after the track; .is-going while it fades,
            [hidden] once every card is out
   Button   button[data-fi-more-btn]
   Cards    .feat-images__item--more siblings in the track; .is-loaded shows
            one. The theme reveal has already marked them .is-in, so .is-in
            is taken off and put back a frame later to replay the deal from
            the pile (--i restarts at 0 for the stagger).
   ========================================================================== */

if (!window.__sukiFeaturedImages) {
  window.__sukiFeaturedImages = true;

  (function () {
    'use strict';

    var Suki = window.Suki;
    if (!Suki) return;

    var BATCH = 3;
    var FADE = 250;

    function setup(more) {
      if (!Suki.claim(more, 'fi-more')) return;
      var section = more.closest('.feat-images');
      var button = more.querySelector('[data-fi-more-btn]');
      if (!section || !button) return;

      var busy = false;

      function waiting() {
        return section.querySelectorAll('.feat-images__item--more:not(.is-loaded)');
      }

      function dealNext() {
        var cards = Array.prototype.slice.call(waiting(), 0, BATCH);
        cards.forEach(function (card, i) {
          card.classList.remove('is-in');
          card.style.setProperty('--i', String(i));
          card.classList.add('is-loaded');
        });
        void section.offsetWidth;
        requestAnimationFrame(function () {
          cards.forEach(function (card) { card.classList.add('is-in'); });
        });
      }

      function load() {
        if (busy) return;
        busy = true;
        more.classList.add('is-going');
        setTimeout(function () {
          dealNext();
          if (!waiting().length) more.hidden = true;
          more.classList.remove('is-going');
          busy = false;
        }, Suki.prefersReducedMotion() ? 0 : FADE);
      }

      button.addEventListener('click', load);
    }

    Suki.register('featuredImagesMore', function init(scope) {
      if (!scope.querySelectorAll) return;
      var found = scope.matches && scope.matches('[data-fi-more]') ? [scope] : scope.querySelectorAll('[data-fi-more]');
      Array.prototype.forEach.call(found, setup);
    });
  })();
}
